var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{active: _vm.preloading},attrs:{"id":"preloadingAssets"}},[_c('b-progress',{attrs:{"size":"is-small","show-value":""}},[_vm._v(_vm._s(_vm.$t('system.loadingAssets'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }